import styled from 'styled-components/native';
import { View } from 'react-native';

import {
  elRed,
  elGray
} from '../../../styles/colors';

export const STATUSES = [
  'Future',
  'Building Run List',
  'Ready For Sale',
  'Pre-Bid',
  'Live',
  'Processing',
  'Closed'
]

export const ButtonContainer = styled(View)`

`;